var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.box,on:{"touchmove":function($event){$event.preventDefault();}}},[_c('div',{class:_vm.$style.content},[_c('img',{attrs:{"src":`${_vm.$cdnUrl}/freeKingdoms/sgin_bg.png`},on:{"click":_vm.jump}}),_c('img',{attrs:{"src":`${_vm.$cdnUrl}/freeKingdoms/close.png`},on:{"click":_vm.close}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }